<template>
    <div class="back-perfil">
        <loading />
        <div class="container pb-5 px-2">
            <div class="criar-conta mt-4">
                <h2 class="text-center text-white"><strong>{{cadastroRealizado == false ? 'Novo Cadastro' : 'Cadastro Realizado'}}</strong></h2>

                <div class="dados-conta bg-white mt-3 rounded p-2 shadow" v-if="!cadastroRealizado">
                    <div class="font-cna my-0 mx-auto m-md-3">
                        <div class="media">
                            <div class="media-body">
                                <div class="w-100 pb-1">
                                    <b-alert show variant="primary">
                                        <span class="text-primary text-sm-left">
                                            Se você já é aluno do CNA, verifique com sua escola se você já tem uma conta com um código de acesso
                                        </span>
                                    </b-alert>
                                </div>

                                <form ref="novo-cadastro"
                                      v-on:submit.prevent="executeEdit(model)"
                                      novalidate
                                      class="form-group">
                                    <div class="row">
                                        <div class="col-md-12 mt-3">
                                            <div>
                                                <h6>DADOS PESSOAIS</h6>
                                            </div>
                                            <div class="row">
                                                <div class="form-group form-group-custom col-md-12">
                                                    <label for="nome" class="bmd-label-floating">Nome Completo</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.nome" />
                                                </div>
                                                <div class="form-group form-group-custom col-md-12">
                                                    <label for="nome" class="bmd-label-floating">E-mail</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.email" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div>
                                                <h6>LOGIN</h6>
                                            </div>
                                            <div class="row">

                                                <div class="form-group form-group-custom col-md-12">
                                                    <label for="nome" class="bmd-label-floating">Usuário</label>
                                                    <input type="text"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.username" />
                                                </div>
                                                <div class="form-group form-group-custom" v-bind:class="[model.password ? 'col-md-6' : 'col-md-12']">
                                                    <label for="nome" class="bmd-label-floating">Senha</label>
                                                    <input type="password"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.password" />
                                                </div>
                                                <div v-if="model.password" class="form-group form-group-custom col-md-6">
                                                    <label for="nome" class="bmd-label-floating">Confirmar Senha</label>
                                                    <input type="password"
                                                           class="form-control"
                                                           name="nome"
                                                           autocomplete="off"
                                                           v-model="model.passwordConfirmacao" />
                                                </div>

                                                <div class="w-100 col-md-12">
                                                    <button type="button"
                                                            class="btn btn-primary btn-round float-right mt-3 btn-block"
                                                            @click="executeEdit(model)">
                                                        Salvar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dados-conta bg-white rounded p-2 shadow" style="margin-top: 17rem;" v-if="cadastroRealizado">
                    <div class="font-cna my-0 mx-auto m-md-3">
                        <div class="media">
                            <div class="media-body pr-md-4 mt-3">
                                <b-alert show variant="success">
                                    <span class="text-success text-sm-left">
                                        Sua conta foi criada com sucesso, feche o navegador e realize o acesso no aplicativo.
                                    </span>
                                </b-alert>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>



<script>
    import { Api } from "@/common/api";
    import loading from '@/common/components/loading'
    import base from "@/common/base";

    export default {
        name: "novo-cadastro",
        mixins: [base],
        components: { loading },
        data: () => ({
            id: null,
            form: "novo-cadastro",
            cadastroRealizado: false,
            pessoaCNAId: null,
            model: {
                nome: '',
                email: '',
                username: '',
                password: '',
                passwordConfirmacao: ''
            },
            modelSave: {
                nome: '',
                email: '',
                username: '',
                password: '',
                passwordConfirmacao: '',
                pessoaCNAId: ''
            },
        }),
        methods: {
            executeEdit(model) {
                if (this.formValidate() == false) return;

                this.showLoading();

                if (this.pessoaCNAId != null)
                    this.modelSave = {
                        pessoaCNAId: this.pessoaCNAId,
                        nome: this.model.nome,
                        email: this.model.email,
                        username: this.model.username,
                        password: this.model.password,
                        passwordConfirmacao: this.model.passwordConfirmacao
                    }

                new Api("pessoacna/CriaNovoAcesso").post(this.pessoaCNAId != null ? this.modelSave : this.model).then(
                    (data) => {
                        this.defaultSuccessResult(
                            "Seu cadastro foi criado com sucesso"
                        );
                        this.cadastroRealizado = true;
                    },
                    (err) => {
                        this.defaultErrorResult(err);

                        this.pessoaCNAId = err.data.data.pessoaCNAId;
                        this.cadastroRealizado = false;

                    }
                );
            },

            formValidate() {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                return _valid;
            },
        },

        mounted() {
            this.id = this.$route.params.id;
        },
    };
</script>